import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BlogTags } from '@app/_shared/_enums/blog-tags';
import { SEO, IShopifyProduct } from '@app/_shared/_models';
import { BlogService, ProductService, SeoService } from '@app/_shared/_services';
import { NgxSpinner, NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { Observable, Subject, takeUntil } from 'rxjs';
import { IBlogPost } from '../_prismic/blog-post';
import { ImageComponent } from '../../_shared/_components/image/image.component';
import { ProductCardComponent } from '../../_shared/_components/product-card/product-card.component';
import { AsyncPipe, UpperCasePipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-why-poolife-phospate-remover-transforms-maintenance',
    templateUrl: './why-poolife-phospate-remover-transforms-maintenance.component.html',
    styleUrls: ['./why-poolife-phospate-remover-transforms-maintenance.component.scss'],
    imports: [NgxSpinnerComponent, ImageComponent, ProductCardComponent, RouterLink, AsyncPipe, UpperCasePipe, DatePipe]
})
export class WhyPoolifePhospateRemoverTransformsMaintenanceComponent implements OnInit, OnDestroy{
  private readonly blogService = inject(BlogService);
  private readonly ngxSpinnerService = inject(NgxSpinnerService);
  private readonly productService = inject(ProductService);
  private readonly seoService = inject(SeoService);

  public seo: SEO = {
    image: 'https://mypoolhut.com/assets/images/algae-in-pool.webp',
    metaDescription: `Discover how Poolife Phosphate Remover transforms pool maintenance by eliminating invisible phosphates that cause algae growth and cloudy water. Learn why phosphate removal is essential for crystal-clear pool water.`,
    metaTitle: `Why Poolife Phosphate Remover Transforms Pool Maintenance`
  };
  public spinner$: Observable<NgxSpinner>;
  public blogPost!: IBlogPost;
  public phosphateRemover: IShopifyProduct | undefined;
  private readonly blogTags = BlogTags;
  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  constructor() {
    const ngxSpinnerService = this.ngxSpinnerService;

    this.spinner$ = ngxSpinnerService.spinnerObservable;
  }

  public async ngOnInit(): Promise<void> {
    this.seoService.setMetaData(this.seo);
    this.seoService.createCanonicalUrl('https://mypoolhut.com/blog/why-poolife-phospate-remover-transforms-maintenance');

    await this.ngxSpinnerService.show();
    this.blogService.blogs$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(async (blogs: Array<IBlogPost>) => {
        const index = blogs.findIndex(b => b.tag === this.blogTags.PHOSPHATE_REMOVAL);
        if (index > -1) {
          this.blogPost = blogs[index];
          await this.ngxSpinnerService.hide();
        } else {
          await this.blogService.loadBlogs();
        }
      });

    this.phosphateRemover = await this.productService.loadProductByHandle('poolife-phosphate-remover');
  }

  public ngOnDestroy(): void {
    this.seoService.removeCanonicalUrl();
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
